<style>
.table-dashboard thead tr td {
    background: #1f2248;
    color: #fff;
}
</style>
<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title=" Laporan Kutipan iBayaq Mengikut Jenis Bayaran">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_dari"
                            required
                            label="Dari"
                            type="date"
                        />
                        <!-- <z-lookup
                            label="Jabatan"
                            :url="service_kutipan + 'lookup/jabatan_user'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.jabatan_id"
                        /> -->
                    </div>
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_hingga"
                            required
                            label="Hingga"
                            type="date"
                        />
                    </div>
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>

            <w-flex justify-center align-center class="mt5">
                <loading v-model:active="isLoading"
                    :can-cancel="false"
                    :opacity="0.7"
                    :is-full-page="false"/>
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" style="width:100%;">
                        <thead>
                            <tr>
                                <td rowspan="2">BIL</td>
                                <td rowspan="2">JABATAN</td>
                                <td colspan="2">CARA BAYARAN (RM)</td>
                                <td rowspan="2">JUMLAH (RM)</td>
                            </tr>
                            <tr>
                                <td>KAD KREDIT</td>
                                <td>FPX</td>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="table.items.length > 0">
                                <tr v-for="(dt, index) in table.items">
                                    <td>{{ dt.no }}</td>
                                    <td>{{ dt.jabatan }}</td>
                                    <td style="text-align: right">{{ dt.amaun_b }}</td>
                                    <td style="text-align: right">{{ dt.amaun_c }}</td>
                                    <td style="text-align: right">{{ dt.amaun_jumlah }}</td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="5" style="text-align: center">Tiada Rekod</td>
                                </tr>
                            </template>
                            <tr>
                                <td colspan="2"><b>JUMLAH</b></td>
                                <td style="text-align: right"><b>{{table.jumlah_b}}</b></td>
                                <td style="text-align: right"><b>{{table.jumlah_c}}</b></td>
                                <td style="text-align: right"><b>{{table.jumlah_total}}</b></td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- <w-card class="text-right">
                        <w-flex
                            v-if="table.meta.current_page"
                            class="justify-start align-center"
                        >
                            <pagination
                                class="xs11"
                                :max="table.meta.last_page"
                                :path="table.meta.path"
                                :current="table.meta.current_page"
                                :last_page="table.meta.last_page"
                                :links="table.meta.links"
                                @pageChanged="table.loadpg"
                            />
                        </w-flex>
                    </w-card> -->
                </div>
            </w-flex>

            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" id="cetak" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

export default {
    extends: ZResource,
    components: {
        // ZenOne
        Loading
    },
    props: {
        items: [Array, Object],
        auth: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_laporan + "kutipan/laporan/dummy",
            reload: true,
            status: [
                {
                    value: 1,
                    label: "Aktif",
                },
                {
                    value: 2,
                    label: "Tidak Aktif",
                },
            ],
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/kutipan/laporan/ibayaq_cara_bayaran"},
                { label: "Laporan", route: "/kutipan/laporan/ibayaq_cara_bayaran"},
                {
                    label: "Laporan Kutipan iBayaq Mengikut Jenis Bayaran",
                    route: "/kutipan/laporan/ibayaq_cara_bayaran",
                },
            ],
            cari: { tarikh_dari: "", tarikh_hingga: "", jabatan_id: "" },
            isLoading: false,
        };
    },
    methods: {
        search() {
            this.getQueryData();
            // this.$inertia.visit(
            //     window.route("kutipan.laporan.ibayaq_cara_bayaran") + 
            //         "?tarikh_dari=" + this.cari.tarikh_dari +
            //         "&tarikh_hingga=" + this.cari.tarikh_hingga+
            //         "&jabatan_id=" + this.cari.jabatan_id,
            //     { preserveScroll: true }
            // );
        },

        reset() {
            this.cari = { tarikh_dari: "", tarikh_hingga: "", jabatan_id: "" };
            this.search();
        },

        cetak() {
            document.getElementById("cetak").disabled = true;
            window.open(this.service_ibayaq+'laporan/ibayaq_cara_bayaran/cetak?user_id='+this.auth.user.id+
            "&tarikh_dari=" + this.cari.tarikh_dari +
            "&tarikh_hingga=" + this.cari.tarikh_hingga+
            "&jabatan_id=" + this.cari.jabatan_id,'_blank');
            },
        async getQueryData() {
            this.isLoading = true;
            const resp = await axios.get(
                this.service_ibayaq + "laporan/ibayaq_cara_bayaran?user_id=" + this.auth.user.id +
                "&tarikh_dari=" + this.cari.tarikh_dari +
                "&tarikh_hingga=" + this.cari.tarikh_hingga+
                "&jabatan_id=" + this.cari.jabatan_id
            );
            this.table = resp.data.data;
            // this.table.meta = resp.data.meta;
            this.isLoading = false;
        },
        },
        watch: {},
    mounted() {
        // console.log(this.datas);
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.tarikh_dari == "undefined") {
            this.cari.tarikh_dari = "";
        }
        if (this.cari.tarikh_hingga == "undefined") {
            this.cari.tarikh_hingga = "";
        }
        if (this.cari.jabatan_id == "undefined") {
            this.cari.jabatan_id = "";
        }
        // console.log(this.auth.user.id);
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
